import { useTranslation } from 'react-i18next'
import { Lock, LogIn, UserPlus } from 'lucide-react'
import { useUiStore } from '../store/uiStore'

/**
 * Obrazovka „je nutné se přihlásit" pro stránky dostupné jen přihlášeným.
 * Použij na začátku stránky: `if (!isAuthenticated) return <LoginRequired feature={...} />`.
 */
export default function LoginRequired({ feature }: { feature?: string }) {
  const { t } = useTranslation()
  const { openAuthModal } = useUiStore()

  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center">
      <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-primary-600 to-accent-500 flex items-center justify-center shadow-lg shadow-primary-500/25">
        <Lock className="w-8 h-8 text-white" />
      </div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        {t('login_required.title', { defaultValue: 'Přihlaste se' })}
      </h1>
      <p className="text-gray-500 dark:text-gray-400 mb-8">
        {feature
          ? t('login_required.desc_feature', { feature, defaultValue: `Funkce „${feature}" je dostupná po přihlášení. Přihlaste se nebo si vytvořte účet zdarma.` })
          : t('login_required.desc', { defaultValue: 'Tato stránka je dostupná jen přihlášeným uživatelům. Přihlaste se nebo si vytvořte účet zdarma.' })}
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <button
          onClick={() => openAuthModal('login')}
          className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary-600 to-primary-500 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg hover:shadow-primary-500/25 transition cursor-pointer"
        >
          <LogIn className="w-4 h-4" />
          {t('login_required.login', { defaultValue: 'Přihlásit se' })}
        </button>
        <button
          onClick={() => openAuthModal('register')}
          className="inline-flex items-center justify-center gap-2 border border-gray-200 dark:border-white/10 text-gray-700 dark:text-gray-300 px-6 py-3 rounded-xl font-semibold hover:bg-gray-50 dark:hover:bg-white/5 transition cursor-pointer"
        >
          <UserPlus className="w-4 h-4" />
          {t('login_required.register', { defaultValue: 'Vytvořit účet zdarma' })}
        </button>
      </div>
    </div>
  )
}
